export enum GTMEvent {
  FORM_SUBMITTED = "form_submitted",
}
